import type {MenuItemConfig} from '@myparcel-frontend/ui';
import {Fulfilment24} from '@myparcel-frontend/icons/legacy';
import {markRaw} from 'vue';

export const getFulfilmentMenu = ({isFulfilmentActive = false, showRequestItem = false}): MenuItemConfig => {
  return {
    type: 'internal',
    to: {
      name: 'fulfilment.request',
    },
    label: 'settings.shop.orders.fulfilment.title',
    icon: markRaw(Fulfilment24),
    show: () => {
      if (!showRequestItem) {
        return false;
      }

      return !isFulfilmentActive;
    },
  };
};
